webpackJsonp([35783957827783],{

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterSocial = function FooterSocial() {
	  return _react2.default.createElement(
	    _styles.FooterContainer,
	    null,
	    _react2.default.createElement(
	      'a',
	      { href: 'https://www.github.com/maisonm', target: '_blank', rel: 'noopener norefferer' },
	      _react2.default.createElement(
	        _styles.LinkSvg,
	        {
	          id: 'Layer_1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: '24',
	          height: '24',
	          viewBox: '0 0 24 24'
	        },
	        _react2.default.createElement('path', {
	          className: 'st0',
	          d: 'M12,0C5.4,0,0,5.4,0,12c0,5.3,3.4,9.8,8.2,11.4C8.8,23.5,9,23.1,9,22.8v-2.2c-3.3,0.7-4-1.4-4-1.4\tc-0.5-1.4-1.3-1.8-1.3-1.8c-1.1-0.7,0.1-0.7,0.1-0.7c1.2,0.1,1.8,1.2,1.8,1.2c1.1,1.8,2.8,1.3,3.5,1c0.1-0.8,0.4-1.3,0.8-1.6\tC7.1,17,4.3,16,4.3,11.4c0-1.3,0.5-2.4,1.2-3.2C5.5,7.9,5,6.6,5.7,5c0,0,1-0.3,3.3,1.2c1-0.3,2-0.4,3-0.4c1,0,2,0.1,3,0.4\tC17.3,4.7,18.3,5,18.3,5c0.7,1.7,0.2,2.9,0.1,3.2c0.8,0.8,1.2,1.9,1.2,3.2c0,4.6-2.8,5.6-5.5,5.9c0.4,0.4,0.8,1.1,0.8,2.2v3.3\tc0,0.3,0.2,0.7,0.8,0.6C20.6,21.8,24,17.3,24,12C24,5.4,18.6,0,12,0z'
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: 'https://www.linkedin.com/in/maisonmoa', target: '_blank', rel: 'noopener norefferer' },
	      _react2.default.createElement(
	        _styles.LinkSvg,
	        { xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24', viewBox: '0 0 24 24' },
	        _react2.default.createElement('path', { d: 'M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z' })
	      )
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: 'https://www.twitter.com/maison_moa', target: '_blank', rel: 'noopener norefferer' },
	      _react2.default.createElement(
	        _styles.LinkSvg,
	        { xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24', viewBox: '0 0 24 24' },
	        _react2.default.createElement('path', { d: 'M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z' })
	      )
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: 'https://www.instagram.com/maison_m', target: '_blank', rel: 'noopener norefferer' },
	      _react2.default.createElement(
	        _styles.LinkSvg,
	        {
	          id: 'Layer_1',
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: '24',
	          height: '24',
	          viewBox: '0 0 24 24'
	        },
	        _react2.default.createElement('path', {
	          className: 'st0',
	          d: 'M12,2.2c3.2,0,3.6,0,4.9,0.1c3.3,0.1,4.8,1.7,4.9,4.9c0.1,1.3,0.1,1.6,0.1,4.8s0,3.6-0.1,4.8\tc-0.1,3.2-1.7,4.8-4.9,4.9c-1.3,0.1-1.6,0.1-4.9,0.1c-3.2,0-3.6,0-4.8-0.1c-3.3-0.1-4.8-1.7-4.9-4.9c-0.1-1.3-0.1-1.6-0.1-4.8\ts0-3.6,0.1-4.8C2.4,4,4,2.4,7.2,2.3C8.4,2.2,8.8,2.2,12,2.2z M12,0C8.7,0,8.3,0,7.1,0.1c-4.4,0.2-6.8,2.6-7,7C0,8.3,0,8.7,0,12\ts0,3.7,0.1,4.9c0.2,4.4,2.6,6.8,7,7C8.3,24,8.7,24,12,24s3.7,0,4.9-0.1c4.4-0.2,6.8-2.6,7-7C24,15.7,24,15.3,24,12s0-3.7-0.1-4.9\tc-0.2-4.4-2.6-6.8-7-7C15.7,0,15.3,0,12,0z M12,5.8c-3.4,0-6.2,2.8-6.2,6.2s2.8,6.2,6.2,6.2s6.2-2.8,6.2-6.2S15.4,5.8,12,5.8z M12,16c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S14.2,16,12,16z M18.4,4.2c-0.8,0-1.4,0.6-1.4,1.4S17.6,7,18.4,7s1.4-0.6,1.4-1.4\tS19.2,4.2,18.4,4.2z'
	        })
	      )
	    )
	  );
	};
	
	// Styles
	exports.default = FooterSocial;
	module.exports = exports['default'];

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LinkSvg = exports.FooterContainer = exports.SiteLink = exports.NavLinksContainer = exports.Bar = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['', ''], ['', '']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  max-width: 100%;\n  height: 55px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 0 4px #020202;\n  padding-left: 15px;\n  padding-right: 15px;\n  margin-bottom: 10px;\n  z-index: 99;\n  background: #fff;\n  position: relative;\n  /* This is the navbar logo home link wrapped in gatsby-link */\n  & > a {\n    display: flex;\n    align-items: center;\n  }\n'], ['\n  max-width: 100%;\n  height: 55px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 0 4px #020202;\n  padding-left: 15px;\n  padding-right: 15px;\n  margin-bottom: 10px;\n  z-index: 99;\n  background: #fff;\n  position: relative;\n  /* This is the navbar logo home link wrapped in gatsby-link */\n  & > a {\n    display: flex;\n    align-items: center;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  ', ';\n'], ['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    display: none;\n  '], ['\n    display: none;\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n  margin: 6px;\n\n  & > a {\n    text-decoration: none;\n    font-size: 0.8em;\n    font-weight: 500;\n    transition: 0.3s;\n    color: #020202;\n\n    &:hover {\n      color: #3a6ea5;\n      transition: 0.3s;\n      letter-spacing: 0.2px;\n    }\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  margin: 6px;\n\n  & > a {\n    text-decoration: none;\n    font-size: 0.8em;\n    font-weight: 500;\n    transition: 0.3s;\n    color: #020202;\n\n    &:hover {\n      color: #3a6ea5;\n      transition: 0.3s;\n      letter-spacing: 0.2px;\n    }\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  bottom: 18px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  opacity: 0;\n  animation: 1.5s ease-in ', ' forwards;\n  animation-delay: 1.5s;\n'], ['\n  position: fixed;\n  bottom: 18px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  opacity: 0;\n  animation: 1.5s ease-in ', ' forwards;\n  animation-delay: 1.5s;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  transition: 0.2s;\n  margin-left: 16px;\n  margin-right: 16px;\n\n  &:hover {\n    fill: #3a6ea5;\n    transition: 0.2s;\n  }\n'], ['\n  transition: 0.2s;\n  margin-left: 16px;\n  margin-right: 16px;\n\n  &:hover {\n    fill: #3a6ea5;\n    transition: 0.2s;\n  }\n']);
	
	var _styledComponents = __webpack_require__(13);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactAnimations = __webpack_require__(20);
	
	var _cssMediaTemplate = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var slideUp = (0, _styledComponents.keyframes)(_templateObject, _reactAnimations.bounceInUp);
	
	var Bar = exports.Bar = _styledComponents2.default.div(_templateObject2);
	
	var NavLinksContainer = exports.NavLinksContainer = _styledComponents2.default.div(_templateObject3, _cssMediaTemplate.media.medium(_templateObject4));
	
	var SiteLink = exports.SiteLink = _styledComponents2.default.div(_templateObject5);
	
	var FooterContainer = exports.FooterContainer = _styledComponents2.default.div(_templateObject6, slideUp);
	
	var LinkSvg = exports.LinkSvg = _styledComponents2.default.svg(_templateObject7);

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(279);
	
	var _FooterSocial = __webpack_require__(27);
	
	var _FooterSocial2 = _interopRequireDefault(_FooterSocial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    _styles.HeroContainer,
	    null,
	    _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Hi there. My name is Maison'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'I\'m a web developer living life in Florida.'
	      )
	    ),
	    _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Feel free to contact me'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'via email at anytime if you have a question.'
	      )
	    ),
	    _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'This website was built with'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'React, Gatsby, GraphQL, and NodeJs.'
	      )
	    ),
	    _react2.default.createElement(_FooterSocial2.default, null)
	  );
	};
	
	//Components
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HeroContainer = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['', ''], ['', '']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  font-weight: 500;\n  letter-spacing: .1px;\n  background-color: #fff;\n  background-image: url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 56 28\' width=\'56\' height=\'28\'%3E%3Cpath fill=\'%233a6ea5\' fill-opacity=\'0.12\' d=\'M56 26v2h-7.75c2.3-1.27 4.94-2 7.75-2zm-26 2a2 2 0 1 0-4 0h-4.09A25.98 25.98 0 0 0 0 16v-2c.67 0 1.34.02 2 .07V14a2 2 0 0 0-2-2v-2a4 4 0 0 1 3.98 3.6 28.09 28.09 0 0 1 2.8-3.86A8 8 0 0 0 0 6V4a9.99 9.99 0 0 1 8.17 4.23c.94-.95 1.96-1.83 3.03-2.63A13.98 13.98 0 0 0 0 0h7.75c2 1.1 3.73 2.63 5.1 4.45 1.12-.72 2.3-1.37 3.53-1.93A20.1 20.1 0 0 0 14.28 0h2.7c.45.56.88 1.14 1.29 1.74 1.3-.48 2.63-.87 4-1.15-.11-.2-.23-.4-.36-.59H26v.07a28.4 28.4 0 0 1 4 0V0h4.09l-.37.59c1.38.28 2.72.67 4.01 1.15.4-.6.84-1.18 1.3-1.74h2.69a20.1 20.1 0 0 0-2.1 2.52c1.23.56 2.41 1.2 3.54 1.93A16.08 16.08 0 0 1 48.25 0H56c-4.58 0-8.65 2.2-11.2 5.6 1.07.8 2.09 1.68 3.03 2.63A9.99 9.99 0 0 1 56 4v2a8 8 0 0 0-6.77 3.74c1.03 1.2 1.97 2.5 2.79 3.86A4 4 0 0 1 56 10v2a2 2 0 0 0-2 2.07 28.4 28.4 0 0 1 2-.07v2c-9.2 0-17.3 4.78-21.91 12H30zM7.75 28H0v-2c2.81 0 5.46.73 7.75 2zM56 20v2c-5.6 0-10.65 2.3-14.28 6h-2.7c4.04-4.89 10.15-8 16.98-8zm-39.03 8h-2.69C10.65 24.3 5.6 22 0 22v-2c6.83 0 12.94 3.11 16.97 8zm15.01-.4a28.09 28.09 0 0 1 2.8-3.86 8 8 0 0 0-13.55 0c1.03 1.2 1.97 2.5 2.79 3.86a4 4 0 0 1 7.96 0zm14.29-11.86c1.3-.48 2.63-.87 4-1.15a25.99 25.99 0 0 0-44.55 0c1.38.28 2.72.67 4.01 1.15a21.98 21.98 0 0 1 36.54 0zm-5.43 2.71c1.13-.72 2.3-1.37 3.54-1.93a19.98 19.98 0 0 0-32.76 0c1.23.56 2.41 1.2 3.54 1.93a15.98 15.98 0 0 1 25.68 0zm-4.67 3.78c.94-.95 1.96-1.83 3.03-2.63a13.98 13.98 0 0 0-22.4 0c1.07.8 2.09 1.68 3.03 2.63a9.99 9.99 0 0 1 16.34 0z\'%3E%3C/path%3E%3C/svg%3E");\n  z-index: -1;\n\n  & span {\n    width: 50%;\n    line-height: 8px;\n  }\n\n  & span > p {\n    font-size: .8em;\n    line-height: 5px;\n  }\n\n  & span:nth-child(1) {\n    border-bottom: solid 1px #3A6EA5;\n    text-align: left;\n    animation: 1.5s ease-in ', ' forwards;\n    opacity: 0;\n  }\n  & span:nth-child(2) {\n    text-align: right;\n    animation: 1.5s ease-in ', ' forwards;\n    animation-delay: .5s;\n    opacity: 0;\n  }\n  & span:nth-child(3) {\n    border-top: solid 1px #3A6EA5;\n    text-align: left;\n    animation: 1.5s ease-in ', ' forwards;\n    animation-delay: 1s;\n    opacity: 0;\n  }\n  \n  ', ';\n\n\n'], ['\n  width: 100%;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  font-weight: 500;\n  letter-spacing: .1px;\n  background-color: #fff;\n  background-image: url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 56 28\' width=\'56\' height=\'28\'%3E%3Cpath fill=\'%233a6ea5\' fill-opacity=\'0.12\' d=\'M56 26v2h-7.75c2.3-1.27 4.94-2 7.75-2zm-26 2a2 2 0 1 0-4 0h-4.09A25.98 25.98 0 0 0 0 16v-2c.67 0 1.34.02 2 .07V14a2 2 0 0 0-2-2v-2a4 4 0 0 1 3.98 3.6 28.09 28.09 0 0 1 2.8-3.86A8 8 0 0 0 0 6V4a9.99 9.99 0 0 1 8.17 4.23c.94-.95 1.96-1.83 3.03-2.63A13.98 13.98 0 0 0 0 0h7.75c2 1.1 3.73 2.63 5.1 4.45 1.12-.72 2.3-1.37 3.53-1.93A20.1 20.1 0 0 0 14.28 0h2.7c.45.56.88 1.14 1.29 1.74 1.3-.48 2.63-.87 4-1.15-.11-.2-.23-.4-.36-.59H26v.07a28.4 28.4 0 0 1 4 0V0h4.09l-.37.59c1.38.28 2.72.67 4.01 1.15.4-.6.84-1.18 1.3-1.74h2.69a20.1 20.1 0 0 0-2.1 2.52c1.23.56 2.41 1.2 3.54 1.93A16.08 16.08 0 0 1 48.25 0H56c-4.58 0-8.65 2.2-11.2 5.6 1.07.8 2.09 1.68 3.03 2.63A9.99 9.99 0 0 1 56 4v2a8 8 0 0 0-6.77 3.74c1.03 1.2 1.97 2.5 2.79 3.86A4 4 0 0 1 56 10v2a2 2 0 0 0-2 2.07 28.4 28.4 0 0 1 2-.07v2c-9.2 0-17.3 4.78-21.91 12H30zM7.75 28H0v-2c2.81 0 5.46.73 7.75 2zM56 20v2c-5.6 0-10.65 2.3-14.28 6h-2.7c4.04-4.89 10.15-8 16.98-8zm-39.03 8h-2.69C10.65 24.3 5.6 22 0 22v-2c6.83 0 12.94 3.11 16.97 8zm15.01-.4a28.09 28.09 0 0 1 2.8-3.86 8 8 0 0 0-13.55 0c1.03 1.2 1.97 2.5 2.79 3.86a4 4 0 0 1 7.96 0zm14.29-11.86c1.3-.48 2.63-.87 4-1.15a25.99 25.99 0 0 0-44.55 0c1.38.28 2.72.67 4.01 1.15a21.98 21.98 0 0 1 36.54 0zm-5.43 2.71c1.13-.72 2.3-1.37 3.54-1.93a19.98 19.98 0 0 0-32.76 0c1.23.56 2.41 1.2 3.54 1.93a15.98 15.98 0 0 1 25.68 0zm-4.67 3.78c.94-.95 1.96-1.83 3.03-2.63a13.98 13.98 0 0 0-22.4 0c1.07.8 2.09 1.68 3.03 2.63a9.99 9.99 0 0 1 16.34 0z\'%3E%3C/path%3E%3C/svg%3E");\n  z-index: -1;\n\n  & span {\n    width: 50%;\n    line-height: 8px;\n  }\n\n  & span > p {\n    font-size: .8em;\n    line-height: 5px;\n  }\n\n  & span:nth-child(1) {\n    border-bottom: solid 1px #3A6EA5;\n    text-align: left;\n    animation: 1.5s ease-in ', ' forwards;\n    opacity: 0;\n  }\n  & span:nth-child(2) {\n    text-align: right;\n    animation: 1.5s ease-in ', ' forwards;\n    animation-delay: .5s;\n    opacity: 0;\n  }\n  & span:nth-child(3) {\n    border-top: solid 1px #3A6EA5;\n    text-align: left;\n    animation: 1.5s ease-in ', ' forwards;\n    animation-delay: 1s;\n    opacity: 0;\n  }\n  \n  ', ';\n\n\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    span {\n      width: 80%;\n    }\n    span > p {\n      font-size: .7em;\n      height: 100%;\n    }\n  '], ['\n    span {\n      width: 80%;\n    }\n    span > p {\n      font-size: .7em;\n      height: 100%;\n    }\n  ']);
	
	var _styledComponents = __webpack_require__(13);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactAnimations = __webpack_require__(20);
	
	var _cssMediaTemplate = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var slideInLeft = (0, _styledComponents.keyframes)(_templateObject, _reactAnimations.bounceInLeft);
	var slideInRight = (0, _styledComponents.keyframes)(_templateObject, _reactAnimations.bounceInRight);
	
	var HeroContainer = exports.HeroContainer = _styledComponents2.default.div(_templateObject2, slideInRight, slideInLeft, slideInRight, _cssMediaTemplate.media.medium(_templateObject3));
	
	exports.default = HeroContainer;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-6bb0d718281e1e40510b.js